import { useState } from 'react';
import qs from 'qs';

import { SOURCE_CHAT_ROOM_VIEWED } from 'features/chat/constant';
import { getChatEligibility } from 'lib/api/chat';
import useGlobalModalStore from 'global/GlobalModalManager/stores/useGlobalModalStore';
import { GlobalModalType } from 'global/GlobalModalManager/types';
import { mainProfileEvents } from 'features/user/analytics/ProfileAnalytics';
import { useRouter } from 'next/router';
import { PROJECT_FOLDER_PATH } from 'constants/app';
import { handleShowAlertMessage } from 'config/requestTrading/errorHandler';

function useChat(source = '') {
  const router = useRouter();
  const setActiveModal = useGlobalModalStore((s) => s.setActiveModal);

  const [fetchingEligibility, setFetchingEligibility] =
    useState<boolean>(false);

  const checkEligibility = async (uname?: string, showLoading?: boolean) => {
    if (showLoading) setFetchingEligibility(true);

    try {
      const eligibility = await getChatEligibility(uname);

      if (showLoading) setFetchingEligibility(false);

      return eligibility.data.data.is_eligible;
    } catch (error) {
      handleShowAlertMessage(error);
      return true;
    }
  };

  const redirectChat = (uname?: string, target?: string) => {
    type Query = { n?: string; source?: number };
    let q: Query = {};

    if (uname) {
      q = {
        n: uname,
      };
    }

    if (source === 'main-profile') {
      q = {
        ...q,
        source: SOURCE_CHAT_ROOM_VIEWED.findIndex(
          (item) => item === 'User Profile',
        ),
      };
    }

    let query = qs.stringify(q);
    query = query ? `?${query}` : '';

    if (target === '_self') {
      router.push(`/chat${query}`);
    } else {
      window.open(`${PROJECT_FOLDER_PATH}/chat${query}`, target);
    }
  };

  const openChatLimit = () => {
    setActiveModal(GlobalModalType.ChatLimit);
  };

  type OpenChat = {
    username?: string;
    target?: string;
    onEligible?: () => void;
    onIneligible?: () => void;
  };

  const openChat = async (props: OpenChat) => {
    const { username, target = '_blank', onEligible, onIneligible } = props;

    setFetchingEligibility(true);

    if (source === 'main-profile') {
      mainProfileEvents.onUserProfileChatSelected();
    }

    const is_eligible = await checkEligibility(username);

    setFetchingEligibility(false);

    if (is_eligible) {
      onEligible?.();
      redirectChat(username, target);
    } else {
      onIneligible?.();
      openChatLimit();
    }
  };

  return {
    isFetching: fetchingEligibility,
    openChat,
    checkEligibility,
    redirectChat,
    openChatLimit,
  };
}

export default useChat;
